var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.stamp
    ? _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("div", { attrs: { "my-15px": "" } }, [
            _vm._m(0),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "image-preview" }, [
                _vm.picture
                  ? _c("img", {
                      staticClass: "img img-fluid",
                      attrs: { src: _vm.picture },
                    })
                  : _c("div", { staticClass: "image-placeholder" }),
              ]),
              _c("input", {
                ref: "stamp_taken_picture",
                staticClass: "form-control",
                attrs: {
                  type: "file",
                  accept: "image/*",
                  name: "stamp_taken_picture",
                  disabled: _vm.disabled,
                },
                on: { change: _vm.uploadImage },
              }),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mx-5" }, [
      _c("h4", [
        _vm._v(" Stamp Taken "),
        _c("span", { staticClass: "small light" }, [
          _vm._v("Recommended size 108 x 108 pixels"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }